import React from 'react';
import AuthContext, { AccessMode } from '../../contexts/AuthContext';

const modeLabels: Record<AccessMode, string> = {
  preview: 'Mode découverte — actions limitées',
  trial: 'Essai en cours',
  active: 'Abonnement actif',
  read_only: 'Lecture seule — réactivez pour modifier',
  blocked: 'Accès bloqué',
};

const bannerStyle: React.CSSProperties = {
  padding: '12px 16px',
  borderRadius: 8,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 12,
};

const variantStyle: Record<AccessMode, React.CSSProperties> = {
  preview: { background: '#fff7e6', color: '#8a4b00', border: '1px solid #ffd591' },
  trial: { background: '#e6f7ff', color: '#004a73', border: '1px solid #91d5ff' },
  active: { background: '#f6ffed', color: '#135200', border: '1px solid #b7eb8f' },
  read_only: { background: '#fff0f6', color: '#9e1068', border: '1px solid #ffadd2' },
  blocked: { background: '#fff1f0', color: '#a8071a', border: '1px solid #ffa39e' },
};

const AccessBanner: React.FC = () => {
  const { access, startTrial } = React.useContext(AuthContext);

  if (!access) return null;
  if (access.access_mode === 'active') return null;

  const endsAt = access.ends_at ? new Date(access.ends_at) : null;
  const now = new Date();
  const daysLeft = endsAt ? Math.max(0, Math.ceil((endsAt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))) : null;

  const onStartTrial = async () => {
    try {
      await startTrial();
    } catch (err) {
      console.error('Impossible de démarrer l’essai', err);
    }
  };

  return (
    <div style={{ ...bannerStyle, ...variantStyle[access.access_mode] }}>
      <div>
        <strong>{modeLabels[access.access_mode]}</strong>
        {access.access_mode === 'trial' && daysLeft !== null && (
          <span style={{ marginLeft: 8 }}>— {daysLeft} jour(s) restant(s)</span>
        )}
        {access.access_mode === 'read_only' && access.grace_ends_at && (
          <span style={{ marginLeft: 8 }}>— période de grâce terminée</span>
        )}
      </div>
      {(['preview', 'read_only'] as AccessMode[]).includes(access.access_mode) && (
        <button
          onClick={onStartTrial}
          style={{ padding: '8px 12px', borderRadius: 6, border: 'none', background: '#1890ff', color: '#fff' }}
        >
          Démarrer l’essai 7 jours
        </button>
      )}
    </div>
  );
};

export default AccessBanner;
